type StringOrNumber = string | number;
type DictionaryType = Array<{ id: StringOrNumber; name: string }>;

const isArrayNotEmpty = (value: any) =>
  Array.isArray(value) && value.length > 0;

const multiNameFromDictionary = (
  dictionary: DictionaryType,
  indicator: Array<StringOrNumber>,
): string => {
  if (!isArrayNotEmpty(dictionary) || !isArrayNotEmpty(indicator)) return '';

  const result: Array<string> = [];
  const set = new Set(indicator);

  for (const item of dictionary) {
    const { id, name } = item;
    if (!set.size) break;

    if (set.has(id)) {
      result.push(name);
      set.delete(id);
    }
  }

  return result.join(', ');
};

export default multiNameFromDictionary;



// WEBPACK FOOTER //
// ./src/tools/multiNameFromDictionary.ts